import { render, staticRenderFns } from "./HazardData.vue?vue&type=template&id=cbc7742c&"
import script from "./HazardData.vue?vue&type=script&lang=js&"
export * from "./HazardData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports